@if (route.data && route.data['showInMenu']) {
    @if (isRoot) {
        @if (hasVisibleChildren()) {
            <button pButton (click)="elementOpen = !elementOpen" pStyleClass="@next" enterFromClass="hidden"
                    enterActiveClass="slidedown" leaveToClass="hidden" leaveActiveClass="slideup" class="px-link">
                @if (route.data && route.data['icon']) {
                    <div class="menu-icon">
                        <icon [icon]="route.data['icon']" pStyleClass="layout-menuitem-icon"></icon>
                    </div>
                }
                <span>{{ route.title }}</span>
                <icon class="menu-toggle-icon" [icon]="elementOpen?'caretUp':'caretDown'"></icon>
            </button>
            <div class="overflow-y-hidden transition-all transition-duration-300 transition-ease-in-out" [ngClass]="{'hidden': isActive()}">
                <ol>
                    @for (child of route.children; track child) {
                        <li menuitem [route]="child" [parentRouterLink]="routerLink"></li>
                    }
                </ol>
            </div>
        } @else {
            <a routerLinkActive="router-link-active" [routerLink]="routerLink">
                @if (route.data && route.data['icon']) {
                    <div class="menu-icon">
                        <icon [icon]="route.data['icon']" pStyleClass="layout-menuitem-icon"></icon>
                    </div>
                }
                <span>{{ route.title }}</span>
            </a>
        }
    } @else {
        <a routerLinkActive="router-link-active" [routerLink]="routerLink">
            @if (route.data && route.data['icon']) {
                <div class="menu-icon">
                    <icon [icon]="route.data['icon']" pStyleClass="layout-menuitem-icon"></icon>
                </div>
            }
            <span>{{route.title}}</span>
        </a>
    }
}
